import type { AffiliationCustom, ReceiptPrintData } from '../types';

export const AFFILIATION_CATEGORY_CODE = 'AFI';

/** The Afiliación block for a receipt, or null when it isn't one (or has no data). */
export function getAffiliation(data: Pick<ReceiptPrintData, 'categoryCode' | 'custom'>): AffiliationCustom | null {
  if (data.categoryCode !== AFFILIATION_CATEGORY_CODE) return null;
  const c = data.custom as Partial<AffiliationCustom>;
  if (!c.adb_code && !c.affiliation_date) return null;
  return {
    adb_code: c.adb_code ?? '',
    affiliation_date: c.affiliation_date ?? '',
    district: c.district ?? '',
    region: c.region ?? '',
  };
}
